<template>
  <div class="payment__boleto">
    <BilletMessage />
    <DocumentInput
      ref="documentInput"
      v-model="payment.document"
      @validate="handleValidate"
    />
  </div>
</template>

<script>
import replaceSpecialCharactersMixin from '@/components/mixins/replaceSpecialCharactersMixin'
import BilletMessage from '@/views/Checkout/partials/steps/Payment/payments/PaymentBillet/BilletMessage/BilletMessage.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import queryPersistance from '@/components/mixins/queryPersistance'
import sendToFlashlight from '@/utils/flashlightService'
import DocumentInput from '../common/DocumentInput.vue'

export default {
  name: 'PaymentBillet',
  components: {
    BilletMessage,
    DocumentInput,
  },
  mixins: [replaceSpecialCharactersMixin, queryPersistance],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          document: null,
        }
      },
    },
  },
  data() {
    return {
      documentIsValid: false,
    }
  },
  computed: {
    ...mapGetters('Checkout', ['getCurrentStep']),
    ...mapGetters('Cart', ['getOrder', 'getHash', 'getOrderId']),
    payment() {
      return this.value
    },
  },
  mounted() {
    if (!this.$route.params.history) {
      this.$router.push({ name: 'new.stepPayment', query: { pl: this.getPl?.pl } })
    } else {
      this.SET_CURRENT_STEP(4)
    }
    this.SET_DISABLED_STATE_PAYMENT(false)
  },
  methods: {
    ...mapMutations('Checkout', [
      'SET_CURRENT_STEP',
      'SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE',
      'SET_STATUS_CART_LOADING',
      'SET_DISABLED_STATE_PAYMENT',
    ]),
    ...mapActions('Checkout', [
      'identify',
      'shipping',
      'fetchCep',
      'paymentBillet',
      'states',
      'createOrder',
      'fetchCart',
    ]),
    previousStep() {
      this.$router.push({ name: 'new.stepPayment', query: { pl: this.getPl?.pl } })
    },
    async nextStep() {
      try {
        this.SET_STATUS_CART_LOADING(true)
        const validate = this.$refs.documentInput.validateDocument(true)
        if (!validate) return this.SET_DISABLED_STATE_PAYMENT(true)
        await this.postCreateOrder()
        await this.postPaymentBillet()
        return true
      } catch (error) {
        throw new Error(error)
      } finally {
        this.SET_STATUS_CART_LOADING(false)
      }
    },
    async postCreateOrder() {
      try {
        const paymentTypes = {
          creditcard: 'CreditCard',
          card: 'CreditCard',
          billet: 'Boleto',
          pix: 'Pix',
        }

        await this.createOrder(paymentTypes.billet)

        return true
      } catch (error) {
        return error
      }
    },
    async postPaymentBillet() {
      try {
        const validate = this.validateDocumentPaymentBilletAndPix()

        if (validate) {
          try {
            const document = this.replaceSpecialCharacters(this.payment.document)
            this.SET_STATUS_CART_LOADING(true)

            await this.paymentBillet({ document })

            const payload = {
              cart: this.getHash,
              order_id: this.getOrderId,
              payment_type: 'boleto',
            }

            sendToFlashlight(payload)

            this.$router.push({
              name: 'new.stepPaymentBilletSuccess',
              params: { history: true },
              query: { pl: this.getPl?.pl },
            })

            return true
          } catch (error) {
            this.$router.push({
              name: 'new.stepPaymentError',
              params: { history: true },
              query: { pl: this.getPl?.pl },
            })
            this.hideButtonActionPayment = false
            this.hideReturnStepPayment = true
            throw new Error(error)
          } finally {
            this.SET_STATUS_CART_LOADING(false)
          }
        }

        return false
      } catch (error) {
        throw new Error(error)
      }
    },
    handleValidate(validation) {
      this.documentIsValid = validation
    },
    validateDocumentPaymentBilletAndPix() {
      try {
        let validate = this.$refs.documentInput.validateDocument(true)

        if (
          this.$route.name === 'new.stepPayment-billet' ||
          this.$route.name === 'new.stepPayment-pix'
        ) {
          validate = this.documentIsValid
        } else {
          validate = true
        }

        return validate
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.payment__boleto {
  width: 100%;
}
</style>
